import { render, staticRenderFns } from "./BpjsKetenagakerjaanInput.vue?vue&type=template&id=6a38a25a&"
import script from "./BpjsKetenagakerjaanInput.vue?vue&type=script&lang=js&"
export * from "./BpjsKetenagakerjaanInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports